// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dataset-detail-modal {
  background: rgba(15, 23, 42, 0.58);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
  box-sizing: border-box;
  padding: 8px;
  overflow: hidden;
}

.dataset-detail-modal .dataset-detail-dialog {
  width: min(1220px, calc(100vw - 16px));
  max-width: 1220px;
  height: 100% !important;
  min-height: 0 !important;
  max-height: none;
  display: flex;
  margin: 0 auto !important;
}

.dataset-detail-modal .modal-content {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  width: 100% !important;
  height: 100% !important;
  min-height: 100% !important;
  max-height: none;
  margin: 0 !important;
  padding: 0;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  border-radius: 22px;
  background: #f8fafc;
  box-shadow: 0 26px 60px rgba(15, 23, 42, 0.18);
}

.dataset-detail-modal .modal-header {
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex-shrink: 0;
  height: 96px !important;
  min-height: 96px !important;
  padding: 34px 24px 26px !important;
  border-bottom: 1px solid #e5e7eb;
  background: #ffffff;
}

.dataset-detail-modal .modal-title {
  display: inline-flex;
  align-items: center;
  margin: 0;
  color: #0f172a;
  font-size: 1.25rem;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1.2;
}

.dataset-detail-header-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
  margin-left: auto;
}

.dataset-detail-action-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 92px;
  height: 40px;
  padding: 0 14px;
  border: 1px solid #1d355a;
  border: 1px solid var(--brand-navy-hover, #1d355a);
  border-radius: 8px;
  background: #142642;
  background: var(--brand-navy, #142642);
  color: #f8fafc;
  font-size: 0.92rem;
  font-weight: 800;
  line-height: 1;
  transition: background 0.16s ease, border-color 0.16s ease, color 0.16s ease, transform 0.16s ease;
}

.dataset-detail-action-button:hover {
  transform: translateY(-1px);
}

.dataset-detail-action-button--edit:hover {
  border-color: #1d355a;
  border-color: var(--brand-navy-hover, #1d355a);
  background: #1d355a;
  background: var(--brand-navy-hover, #1d355a);
  color: #ffffff;
}

.dataset-detail-action-button--delete {
  border-color: #fecaca;
  background: #ffffff;
  color: #991b1b;
}

.dataset-detail-action-button--delete:hover {
  border-color: #b91c1c;
  background: #b91c1c;
  color: #ffffff;
}

.dataset-detail-request-button {
  margin-left: 0;
  font-weight: 700;
}

.dataset-detail-header-actions + .close {
  margin-left: 0;
}

.dataset-detail-modal .dataset-detail-body {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 22px;
  min-height: 0;
  max-height: none;
  padding: 28px;
  overflow-y: auto;
  background:
    linear-gradient(180deg, #ffffff 0, #f8fafc 260px),
    #f8fafc;
  scrollbar-width: thin;
  scrollbar-color: #7e93ae #edf3f8;
  scrollbar-gutter: stable;
  overscroll-behavior: contain;
}

.dataset-detail-modal .dataset-detail-body::-webkit-scrollbar {
  width: 10px;
}

.dataset-detail-modal .dataset-detail-body::-webkit-scrollbar-track {
  border-radius: 999px;
  background: #edf3f8;
}

.dataset-detail-modal .dataset-detail-body::-webkit-scrollbar-thumb {
  min-height: 2.5rem;
  border: 2px solid #edf3f8;
  border-radius: 999px;
  background: #7e93ae;
}

.dataset-detail-modal .dataset-detail-body::-webkit-scrollbar-thumb:hover {
  background: #142642;
}

.dataset-detail-hero,
.dataset-detail-card {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.07);
}

.dataset-detail-hero {
  padding: 30px 32px;
}

.detail-predicate-label {
  margin: 0 0 8px;
  color: #334155;
  font-size: 0.82rem;
  font-weight: 800;
  letter-spacing: 0;
}

.dataset-detail-hero h2 {
  margin: 0;
  color: #0f172a;
  font-size: 2.15rem;
  font-weight: 800;
  line-height: 1.16;
  letter-spacing: 0;
  overflow-wrap: anywhere;
}

.dataset-detail-description {
  margin-top: 30px;
  padding-top: 24px;
  border-top: 1px solid #eef2f7;
}

.dataset-detail-description p {
  max-width: 980px;
  margin: 0;
  color: #334155;
  font-size: 1rem;
  line-height: 1.65;
  white-space: pre-wrap;
}

.dataset-detail-section {
  margin: 0;
}

.dataset-detail-card {
  padding: 24px 26px;
}

.dataset-detail-section h3 {
  margin: 0 0 18px;
  color: #0f172a;
  font-size: 1.28rem;
  font-weight: 800;
  letter-spacing: 0;
}

.detail-file-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detail-file-row {
  display: grid;
  grid-template-columns: 58px minmax(0, 1fr) auto;
  align-items: center;
  grid-gap: 18px;
  gap: 18px;
  min-height: 92px;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fbfdff;
}

.detail-file-row.is-restricted {
  opacity: 0.68;
}

.detail-file-icon {
  position: relative;
  width: 44px;
  height: 56px;
  display: inline-flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 8px;
  border: 2px solid #f97316;
  border-radius: 6px;
  background: #fff7ed;
  color: #c2410c;
  box-shadow: inset 0 0 0 2px #ffffff;
}

.detail-file-icon::before {
  content: "";
  position: absolute;
  top: -2px;
  right: -2px;
  width: 16px;
  height: 16px;
  border-left: 2px solid #f97316;
  border-bottom: 2px solid #f97316;
  border-radius: 0 4px 0 3px;
  background: #ffffff;
  clip-path: polygon(0 0, 100% 100%, 0 100%);
}

.detail-file-icon.semantic {
  border-color: #2563eb;
  background: #eff6ff;
  color: #1d4ed8;
}

.detail-file-icon.semantic::before {
  border-left-color: #2563eb;
  border-bottom-color: #2563eb;
}

.detail-file-icon-code {
  position: relative;
  z-index: 1;
  max-width: 36px;
  overflow: hidden;
  color: inherit;
  font-size: 0.58rem;
  font-weight: 900;
  line-height: 1;
  text-align: center;
  text-overflow: ellipsis;
  text-transform: uppercase;
}

.detail-file-main {
  min-width: 0;
}

.detail-file-title {
  color: #111827;
  font-size: 1rem;
  font-weight: 800;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.detail-file-meta {
  margin-top: 2px;
  color: #475569;
  font-size: 0.9rem;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.detail-download-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 128px;
  height: 40px;
  padding: 0 18px;
  border: 0;
  border-radius: 8px;
  background: #142642;
  background: var(--brand-navy, #142642);
  color: #ffffff;
  font-size: 0.92rem;
  font-weight: 800;
  box-shadow: 0 10px 20px rgba(20, 38, 66, 0.22);
  box-shadow: 0 10px 20px var(--brand-navy-shadow, rgba(20, 38, 66, 0.22));
  transition: background 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease;
}

.detail-download-button:hover:not(:disabled) {
  background: #1d355a;
  background: var(--brand-navy-hover, #1d355a);
  box-shadow: 0 14px 24px rgba(20, 38, 66, 0.26);
  transform: translateY(-1px);
}

.detail-download-button:disabled {
  cursor: not-allowed;
  background: #e2e8f0;
  color: #94a3b8;
  box-shadow: none;
}

.detail-theme-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 18px;
  padding: 2px 0 0 12px;
}

.detail-theme-chip {
  position: relative;
  display: inline-flex;
  align-items: center;
  min-height: 30px;
  max-width: 100%;
  padding: 5px 14px 5px 18px;
  border: 1px solid #c5dbff;
  border-left: 0;
  border-radius: 0 6px 6px 0;
  background: #eaf2ff;
  color: #1d4ed8;
  font-size: 0.86rem;
  font-weight: 700;
  line-height: 1.2;
}

.detail-theme-chip::before {
  content: "";
  position: absolute;
  top: -1px;
  left: -15px;
  width: 0;
  height: 0;
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-right: 15px solid #c5dbff;
}

.detail-theme-chip::after {
  content: "";
  position: absolute;
  top: 0;
  left: -13px;
  width: 0;
  height: 0;
  border-top: 14px solid transparent;
  border-bottom: 14px solid transparent;
  border-right: 14px solid #eaf2ff;
}

.detail-metadata-table {
  width: 100%;
  margin: 0;
  border-collapse: collapse;
  table-layout: fixed;
}

.detail-metadata-table th,
.detail-metadata-table td {
  padding: 14px 16px;
  border-bottom: 1px solid #e2e8f0;
  vertical-align: top;
}

.detail-metadata-table tr:last-child th,
.detail-metadata-table tr:last-child td {
  border-bottom: 0;
}

.detail-metadata-table th {
  width: 240px;
  color: #334155;
  font-size: 0.9rem;
  font-weight: 800;
  background: #f8fafc;
}

.detail-metadata-table td {
  color: #0f172a;
  font-size: 0.92rem;
  overflow-wrap: anywhere;
}

.detail-metadata-table a {
  color: #0b65d8;
  font-weight: 700;
  text-decoration: none;
}

.detail-metadata-table a:hover {
  text-decoration: underline;
}

.detail-series-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detail-series-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 14px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fbfdff;
}

.detail-series-title {
  color: #0f172a;
  font-weight: 800;
}

.detail-series-description {
  margin-top: 4px;
  color: #64748b;
  font-size: 0.92rem;
}

.detail-graph-wide {
  width: 100%;
  min-height: 520px;
  overflow: hidden;
  border: 1px solid #dbe3ef;
  border-radius: 10px;
  background: #ffffff;
}

.detail-graph-wide .rdf-graph-container {
  width: 100%;
  height: 520px;
}

.detail-graph-wide > .text-muted {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 520px;
  margin: 0;
}

@media (max-width: 900px) {
  .dataset-detail-modal .dataset-detail-dialog {
    width: 100vw;
    max-width: 100vw;
    max-height: 100vh;
    margin: 0;
  }

  .dataset-detail-modal .modal-content {
    max-height: 100vh;
    border-radius: 0;
  }

  .dataset-detail-modal .modal-header {
    height: auto !important;
    align-items: flex-start;
    flex-wrap: wrap;
    padding: 22px 18px !important;
  }

  .dataset-detail-modal .modal-title {
    flex: 1 1 auto;
  }

  .dataset-detail-header-actions {
    order: 2;
    justify-content: flex-start;
    width: 100%;
    margin-left: 0;
  }

  .dataset-detail-modal .modal-header .close {
    margin-left: auto;
  }

  .dataset-detail-modal .dataset-detail-body {
    max-height: none;
    padding: 18px;
  }

  .dataset-detail-hero,
  .dataset-detail-card {
    border-radius: 9px;
  }

  .dataset-detail-hero {
    padding: 22px;
  }

  .dataset-detail-hero h2 {
    font-size: 1.55rem;
  }

  .dataset-detail-card {
    padding: 20px;
  }

  .detail-file-row {
    grid-template-columns: 52px minmax(0, 1fr);
    align-items: flex-start;
    gap: 12px;
  }

  .detail-download-button {
    grid-column: 2;
    width: 100%;
    max-width: 220px;
  }

  .detail-metadata-table,
  .detail-metadata-table tbody,
  .detail-metadata-table tr,
  .detail-metadata-table th,
  .detail-metadata-table td {
    display: block;
    width: 100%;
  }

  .detail-metadata-table th {
    padding-bottom: 4px;
  }

  .detail-metadata-table td {
    padding-top: 4px;
  }

  .detail-series-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .detail-graph-wide,
  .detail-graph-wide .rdf-graph-container,
  .detail-graph-wide > .text-muted {
    min-height: 420px;
    height: 420px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DatasetDetailModal.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,kCAA0B;UAA1B,0BAA0B;EAC1B,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;EACV,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;EAClC,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,eAAe;EACf,yBAAkD;EAAlD,kDAAkD;EAClD,kBAAkB;EAClB,mBAAsC;EAAtC,sCAAsC;EACtC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kGAAkG;AACpG;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAA8C;EAA9C,8CAA8C;EAC9C,mBAA4C;EAA5C,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB;;WAES;EACT,qBAAqB;EACrB,gCAAgC;EAChC,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,cAAS;EAAT,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,gCAAgC;EAChC,0BAA0B;EAC1B,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,mBAAsC;EAAtC,sCAAsC;EACtC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,8CAAwE;EAAxE,wEAAwE;EACxE,8EAA8E;AAChF;;AAEA;EACE,mBAA4C;EAA5C,4CAA4C;EAC5C,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;EACzB,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,SAAS;EACT,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0CAA0C;IAC1C,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;EAClB;;EAEA;;;;;IAKE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;;IAGE,iBAAiB;IACjB,aAAa;EACf;AACF","sourcesContent":[".dataset-detail-modal {\n  background: rgba(15, 23, 42, 0.58);\n  backdrop-filter: blur(2px);\n  box-sizing: border-box;\n  padding: 8px;\n  overflow: hidden;\n}\n\n.dataset-detail-modal .dataset-detail-dialog {\n  width: min(1220px, calc(100vw - 16px));\n  max-width: 1220px;\n  height: 100% !important;\n  min-height: 0 !important;\n  max-height: none;\n  display: flex;\n  margin: 0 auto !important;\n}\n\n.dataset-detail-modal .modal-content {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  width: 100% !important;\n  height: 100% !important;\n  min-height: 100% !important;\n  max-height: none;\n  margin: 0 !important;\n  padding: 0;\n  overflow: hidden;\n  border: 1px solid #e5e7eb;\n  border-radius: 22px;\n  background: #f8fafc;\n  box-shadow: 0 26px 60px rgba(15, 23, 42, 0.18);\n}\n\n.dataset-detail-modal .modal-header {\n  box-sizing: border-box;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  flex-shrink: 0;\n  height: 96px !important;\n  min-height: 96px !important;\n  padding: 34px 24px 26px !important;\n  border-bottom: 1px solid #e5e7eb;\n  background: #ffffff;\n}\n\n.dataset-detail-modal .modal-title {\n  display: inline-flex;\n  align-items: center;\n  margin: 0;\n  color: #0f172a;\n  font-size: 1.25rem;\n  font-weight: 800;\n  letter-spacing: 0;\n  line-height: 1.2;\n}\n\n.dataset-detail-header-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-left: auto;\n}\n\n.dataset-detail-action-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-width: 92px;\n  height: 40px;\n  padding: 0 14px;\n  border: 1px solid var(--brand-navy-hover, #1d355a);\n  border-radius: 8px;\n  background: var(--brand-navy, #142642);\n  color: #f8fafc;\n  font-size: 0.92rem;\n  font-weight: 800;\n  line-height: 1;\n  transition: background 0.16s ease, border-color 0.16s ease, color 0.16s ease, transform 0.16s ease;\n}\n\n.dataset-detail-action-button:hover {\n  transform: translateY(-1px);\n}\n\n.dataset-detail-action-button--edit:hover {\n  border-color: var(--brand-navy-hover, #1d355a);\n  background: var(--brand-navy-hover, #1d355a);\n  color: #ffffff;\n}\n\n.dataset-detail-action-button--delete {\n  border-color: #fecaca;\n  background: #ffffff;\n  color: #991b1b;\n}\n\n.dataset-detail-action-button--delete:hover {\n  border-color: #b91c1c;\n  background: #b91c1c;\n  color: #ffffff;\n}\n\n.dataset-detail-request-button {\n  margin-left: 0;\n  font-weight: 700;\n}\n\n.dataset-detail-header-actions + .close {\n  margin-left: 0;\n}\n\n.dataset-detail-modal .dataset-detail-body {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  gap: 22px;\n  min-height: 0;\n  max-height: none;\n  padding: 28px;\n  overflow-y: auto;\n  background:\n    linear-gradient(180deg, #ffffff 0, #f8fafc 260px),\n    #f8fafc;\n  scrollbar-width: thin;\n  scrollbar-color: #7e93ae #edf3f8;\n  scrollbar-gutter: stable;\n  overscroll-behavior: contain;\n}\n\n.dataset-detail-modal .dataset-detail-body::-webkit-scrollbar {\n  width: 10px;\n}\n\n.dataset-detail-modal .dataset-detail-body::-webkit-scrollbar-track {\n  border-radius: 999px;\n  background: #edf3f8;\n}\n\n.dataset-detail-modal .dataset-detail-body::-webkit-scrollbar-thumb {\n  min-height: 2.5rem;\n  border: 2px solid #edf3f8;\n  border-radius: 999px;\n  background: #7e93ae;\n}\n\n.dataset-detail-modal .dataset-detail-body::-webkit-scrollbar-thumb:hover {\n  background: #142642;\n}\n\n.dataset-detail-hero,\n.dataset-detail-card {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #ffffff;\n  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.07);\n}\n\n.dataset-detail-hero {\n  padding: 30px 32px;\n}\n\n.detail-predicate-label {\n  margin: 0 0 8px;\n  color: #334155;\n  font-size: 0.82rem;\n  font-weight: 800;\n  letter-spacing: 0;\n}\n\n.dataset-detail-hero h2 {\n  margin: 0;\n  color: #0f172a;\n  font-size: 2.15rem;\n  font-weight: 800;\n  line-height: 1.16;\n  letter-spacing: 0;\n  overflow-wrap: anywhere;\n}\n\n.dataset-detail-description {\n  margin-top: 30px;\n  padding-top: 24px;\n  border-top: 1px solid #eef2f7;\n}\n\n.dataset-detail-description p {\n  max-width: 980px;\n  margin: 0;\n  color: #334155;\n  font-size: 1rem;\n  line-height: 1.65;\n  white-space: pre-wrap;\n}\n\n.dataset-detail-section {\n  margin: 0;\n}\n\n.dataset-detail-card {\n  padding: 24px 26px;\n}\n\n.dataset-detail-section h3 {\n  margin: 0 0 18px;\n  color: #0f172a;\n  font-size: 1.28rem;\n  font-weight: 800;\n  letter-spacing: 0;\n}\n\n.detail-file-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.detail-file-row {\n  display: grid;\n  grid-template-columns: 58px minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 18px;\n  min-height: 92px;\n  padding: 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #fbfdff;\n}\n\n.detail-file-row.is-restricted {\n  opacity: 0.68;\n}\n\n.detail-file-icon {\n  position: relative;\n  width: 44px;\n  height: 56px;\n  display: inline-flex;\n  align-items: flex-end;\n  justify-content: center;\n  padding-bottom: 8px;\n  border: 2px solid #f97316;\n  border-radius: 6px;\n  background: #fff7ed;\n  color: #c2410c;\n  box-shadow: inset 0 0 0 2px #ffffff;\n}\n\n.detail-file-icon::before {\n  content: \"\";\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  width: 16px;\n  height: 16px;\n  border-left: 2px solid #f97316;\n  border-bottom: 2px solid #f97316;\n  border-radius: 0 4px 0 3px;\n  background: #ffffff;\n  clip-path: polygon(0 0, 100% 100%, 0 100%);\n}\n\n.detail-file-icon.semantic {\n  border-color: #2563eb;\n  background: #eff6ff;\n  color: #1d4ed8;\n}\n\n.detail-file-icon.semantic::before {\n  border-left-color: #2563eb;\n  border-bottom-color: #2563eb;\n}\n\n.detail-file-icon-code {\n  position: relative;\n  z-index: 1;\n  max-width: 36px;\n  overflow: hidden;\n  color: inherit;\n  font-size: 0.58rem;\n  font-weight: 900;\n  line-height: 1;\n  text-align: center;\n  text-overflow: ellipsis;\n  text-transform: uppercase;\n}\n\n.detail-file-main {\n  min-width: 0;\n}\n\n.detail-file-title {\n  color: #111827;\n  font-size: 1rem;\n  font-weight: 800;\n  line-height: 1.35;\n  overflow-wrap: anywhere;\n}\n\n.detail-file-meta {\n  margin-top: 2px;\n  color: #475569;\n  font-size: 0.9rem;\n  line-height: 1.45;\n  overflow-wrap: anywhere;\n}\n\n.detail-download-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 128px;\n  height: 40px;\n  padding: 0 18px;\n  border: 0;\n  border-radius: 8px;\n  background: var(--brand-navy, #142642);\n  color: #ffffff;\n  font-size: 0.92rem;\n  font-weight: 800;\n  box-shadow: 0 10px 20px var(--brand-navy-shadow, rgba(20, 38, 66, 0.22));\n  transition: background 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease;\n}\n\n.detail-download-button:hover:not(:disabled) {\n  background: var(--brand-navy-hover, #1d355a);\n  box-shadow: 0 14px 24px rgba(20, 38, 66, 0.26);\n  transform: translateY(-1px);\n}\n\n.detail-download-button:disabled {\n  cursor: not-allowed;\n  background: #e2e8f0;\n  color: #94a3b8;\n  box-shadow: none;\n}\n\n.detail-theme-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px 18px;\n  padding: 2px 0 0 12px;\n}\n\n.detail-theme-chip {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  min-height: 30px;\n  max-width: 100%;\n  padding: 5px 14px 5px 18px;\n  border: 1px solid #c5dbff;\n  border-left: 0;\n  border-radius: 0 6px 6px 0;\n  background: #eaf2ff;\n  color: #1d4ed8;\n  font-size: 0.86rem;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.detail-theme-chip::before {\n  content: \"\";\n  position: absolute;\n  top: -1px;\n  left: -15px;\n  width: 0;\n  height: 0;\n  border-top: 15px solid transparent;\n  border-bottom: 15px solid transparent;\n  border-right: 15px solid #c5dbff;\n}\n\n.detail-theme-chip::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -13px;\n  width: 0;\n  height: 0;\n  border-top: 14px solid transparent;\n  border-bottom: 14px solid transparent;\n  border-right: 14px solid #eaf2ff;\n}\n\n.detail-metadata-table {\n  width: 100%;\n  margin: 0;\n  border-collapse: collapse;\n  table-layout: fixed;\n}\n\n.detail-metadata-table th,\n.detail-metadata-table td {\n  padding: 14px 16px;\n  border-bottom: 1px solid #e2e8f0;\n  vertical-align: top;\n}\n\n.detail-metadata-table tr:last-child th,\n.detail-metadata-table tr:last-child td {\n  border-bottom: 0;\n}\n\n.detail-metadata-table th {\n  width: 240px;\n  color: #334155;\n  font-size: 0.9rem;\n  font-weight: 800;\n  background: #f8fafc;\n}\n\n.detail-metadata-table td {\n  color: #0f172a;\n  font-size: 0.92rem;\n  overflow-wrap: anywhere;\n}\n\n.detail-metadata-table a {\n  color: #0b65d8;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.detail-metadata-table a:hover {\n  text-decoration: underline;\n}\n\n.detail-series-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.detail-series-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 18px;\n  padding: 14px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #fbfdff;\n}\n\n.detail-series-title {\n  color: #0f172a;\n  font-weight: 800;\n}\n\n.detail-series-description {\n  margin-top: 4px;\n  color: #64748b;\n  font-size: 0.92rem;\n}\n\n.detail-graph-wide {\n  width: 100%;\n  min-height: 520px;\n  overflow: hidden;\n  border: 1px solid #dbe3ef;\n  border-radius: 10px;\n  background: #ffffff;\n}\n\n.detail-graph-wide .rdf-graph-container {\n  width: 100%;\n  height: 520px;\n}\n\n.detail-graph-wide > .text-muted {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 520px;\n  margin: 0;\n}\n\n@media (max-width: 900px) {\n  .dataset-detail-modal .dataset-detail-dialog {\n    width: 100vw;\n    max-width: 100vw;\n    max-height: 100vh;\n    margin: 0;\n  }\n\n  .dataset-detail-modal .modal-content {\n    max-height: 100vh;\n    border-radius: 0;\n  }\n\n  .dataset-detail-modal .modal-header {\n    height: auto !important;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    padding: 22px 18px !important;\n  }\n\n  .dataset-detail-modal .modal-title {\n    flex: 1 1 auto;\n  }\n\n  .dataset-detail-header-actions {\n    order: 2;\n    justify-content: flex-start;\n    width: 100%;\n    margin-left: 0;\n  }\n\n  .dataset-detail-modal .modal-header .close {\n    margin-left: auto;\n  }\n\n  .dataset-detail-modal .dataset-detail-body {\n    max-height: none;\n    padding: 18px;\n  }\n\n  .dataset-detail-hero,\n  .dataset-detail-card {\n    border-radius: 9px;\n  }\n\n  .dataset-detail-hero {\n    padding: 22px;\n  }\n\n  .dataset-detail-hero h2 {\n    font-size: 1.55rem;\n  }\n\n  .dataset-detail-card {\n    padding: 20px;\n  }\n\n  .detail-file-row {\n    grid-template-columns: 52px minmax(0, 1fr);\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .detail-download-button {\n    grid-column: 2;\n    width: 100%;\n    max-width: 220px;\n  }\n\n  .detail-metadata-table,\n  .detail-metadata-table tbody,\n  .detail-metadata-table tr,\n  .detail-metadata-table th,\n  .detail-metadata-table td {\n    display: block;\n    width: 100%;\n  }\n\n  .detail-metadata-table th {\n    padding-bottom: 4px;\n  }\n\n  .detail-metadata-table td {\n    padding-top: 4px;\n  }\n\n  .detail-series-row {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .detail-graph-wide,\n  .detail-graph-wide .rdf-graph-container,\n  .detail-graph-wide > .text-muted {\n    min-height: 420px;\n    height: 420px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
